import { Listbox } from "@headlessui/react";
import ChevronDownIcon from "../assets/images/dropDownIcon.svg";

export default function CustomSelect({
  selected,
  onChange,
  options = [],
  disabled = false,
  fullWidth = false,
    fontSize = "",
  placeholderFontSize = "",
}) {
  return (
    <div className={`relative w-full ${fullWidth ? "" : "max-w-sm"}`}>
      <Listbox value={selected} onChange={onChange} disabled={disabled}>
        <div className="relative">
          <Listbox.Button
            className={`w-full  cursor-pointer rounded-lg bg-white border border-gray-300  px-2 py-2 pr-10 text-left text-sm font-medium text-gray-900 flex justify-between items-center `}
          >
           <span className={`boxText truncate w-full block whitespace-nowrap overflow-hidden text-ellipsis p-1 ${selected ? fontSize : placeholderFontSize}`}>
              {selected || (
                <span className={`${disabled ? "text-gray-400" : ""} ${placeholderFontSize}`}>
                  Select an option
                </span>
              )}
            </span>

            <img
              src={ChevronDownIcon}
              alt="Dropdown icon"
              className={`w-5 h-5 ${disabled ? "opacity-40" : ""}`}
            />
          </Listbox.Button>

          <Listbox.Options className="absolute right-0 z-10 mt-2 max-h-60 w-full overflow-auto rounded-lg bg-white py-1 text-sm shadow-lg ring-1 ring-black/5 focus:outline-none border border-gray-200">
            {options.map((option, idx) => (
              <Listbox.Option
                key={idx}
                value={option.label}
                className={({ active }) =>
                  `boxText cursor-pointer select-none px-4 py-3 ${
                    active ? "bg-[#73c7a9] text-gray-900" : "text-gray-700"
                  }`
                }
              >
                {option.label}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      </Listbox>
    </div>
  );
}
